module.exports = __webpack_public_path__ + "img/pdf.56615b41.jpg";